import React from 'react';
import {
  FluentProvider, Theme, makeStyles, mergeClasses, tokens, webLightTheme, shorthands,
} from '@fluentui/react-components';
import { Textarea } from '@fluentai/textarea';
import { I18nProvider } from '@bingads-webui/copilot-i18n';
import { Header, IHeaderProps } from '@bingads-webui-react/copilot-ui-base';
import { Loading } from './Loading';

interface IPreparingViewProps extends IHeaderProps {
  loadingText?: string;
  theme?: Theme;
  chatInputPlaceholder?: string;
  locale?: string;
}

const usePreparingViewStyles = makeStyles({
  provider: {
    height: '100%',
  },
  wrapper: {
    height: '100%',
  },
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: tokens.colorNeutralBackground2,
    borderLeftWidth: '1px',
    borderLeftStyle: 'solid',
    borderLeftColor: tokens.colorNeutralStroke1,
  },
  loadingWrapper: {
    ...shorthands.flex(1),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  chatInputWrapper: {
    alignSelf: 'center',
    maxWidth: '652px',
    width: '100%',
    ...shorthands.padding('16px'),
  },
});

export const PreparingView: React.FC<IPreparingViewProps> = React.memo((props) => {
  const styles = usePreparingViewStyles();
  const { theme, chatInputPlaceholder, locale } = props;
  return (
    <FluentProvider theme={theme} className={mergeClasses(styles.provider, 'ads-copilot-preparing-view')} applyStylesToPortals={false}>
      <I18nProvider locale={locale}>
        <div className={styles.root}>
          <Header {...props} />
          <div className={mergeClasses(styles.loadingWrapper, 'loading-wrapper')}>
            <Loading loadingText={props.loadingText} />
          </div>
          <div className={mergeClasses(styles.chatInputWrapper, 'chat-input-wrapper')}>
            <Textarea
              disabled
              mode="sidecar"
              placeholder={chatInputPlaceholder}
            />
          </div>
        </div>
      </I18nProvider>
    </FluentProvider>
  );
});

PreparingView.defaultProps = {
  theme: webLightTheme,
  loadingText: 'Preparing Copilot...',
  chatInputPlaceholder: 'Ask a question',
  locale: 'en-us',
};
